import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton } from "@ionic/react";
import { useUserDetails } from "../hooks/useUserDetails";
import { useAutoSignInStatus } from "../hooks/useAutoSignInStatus";

import "./SignInCard.css";

const SignInCard: React.FC = () => {
  const { instance } = useUserDetails();
  const autoSignInStatus = useAutoSignInStatus();
  const manualSignInEnabled =
    autoSignInStatus === "failed" || autoSignInStatus === "skipped";

  return (
    <div className="sign-in-container">
      <IonCard className="sign-in-card">
        <IonCardHeader>
          <IonCardTitle>Group Manager</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <p className="sign-in-description">
            Sign in with your Pymble staff account to manage groups,
            memberships, and notifications.
          </p>
          <IonButton
            data-testid="sign-in-card-button"
            expand="block"
            disabled={!manualSignInEnabled}
            onClick={
              manualSignInEnabled
                ? () => void instance.loginRedirect()
                : undefined
            }
          >
            Sign In
          </IonButton>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default SignInCard;
